export const TABLE_HEIGHT = 600;
export const BAR_CELL_PADDING = 12;
export const SORTING_ARROW_WIDTH = 24;
